import { render, staticRenderFns } from "./WarehouseDetailHeader.vue?vue&type=template&id=60fdf004&scoped=true&"
import script from "./WarehouseDetailHeader.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetailHeader.vue?vue&type=style&index=0&id=60fdf004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fdf004",
  null
  
)

export default component.exports